import { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    TablePagination,
    Button,
    CircularProgress,
    Typography,
    Box
} from '@mui/material';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';

const RewriteRequestTable = ({setHasClicked, hasClicked}) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [groups, setGroups] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isResolveModalOpen, setIsResolveModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const areAllApproved = (group) => group.result.every(item => item.approved);
    const areAllResolved = (group) => group.result.every(item => item.resolved);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch {
                setRoleId("");
            }
        }
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        const res = await axios.get(`${baseURL}/GetAllCaseRewriteRequestAndLog?PageSize=${rowsPerPage}&Page=${page}`);
        setGroups(res.data.data.caseRewriteRequestResultItems || []);
        setTotalCount(res.data.data.listCount || 0);
        setIsLoading(false);
    };

    const seenByHeadOfAgency = async () => {
        try {
            await axios.put(`${baseURL}/UpdateCaseRewriteRequesLoggerViewedByHeadOfAgencyTrue`, {});
        }
        catch {}
    };

    const getCaseCount = async () => {
        try {
            await axios.get(`${baseURL}/GetAllCaseRewriteRequestAndLog?GetViewedByHeadOfAgencycount=true`, {});
        }
        catch {}
    };
    useEffect(() => {
        getCaseCount()
    }, []);

    useEffect(() => {
        void seenByHeadOfAgency();
    }, []);



    const approveCases = async () => {
        if (!selectedGroup) return;
        try {
            const caseRewriteRequestIds = selectedGroup.result.map(item => item.id);
            await axios.put(`${baseURL}/ApproveRewriteRequest`, {
                ids: caseRewriteRequestIds,
                approve: true
            });
        } finally {
            setIsApproveModalOpen(false);
            setSelectedGroup(null);
            setOpen(false);
            void fetchData();
        }
    };

    const resolveCases = async () => {
        if (!selectedGroup) return;
        try {
            const caseRewriteRequestIds = selectedGroup.result.map(item => item.id);
            await axios.put(`${baseURL}/ResolveRewriteRequest`, {
                id: caseRewriteRequestIds,
            });
        } finally {
            setHasClicked(Math.floor(Math.random() * 100));
            setIsResolveModalOpen(false);
            setSelectedGroup(null);
            setOpen(false);
            void fetchData();
        }
    };



    useEffect(() => {
        void fetchData();
    }, [page]);

    return (
        <>
            <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableRow>
                            <TableCell>განაცხადის ნომრები</TableCell>
                            <TableCell>რაოდენობა</TableCell>
                            <TableCell>სააგენტოს უფროსის დადასტურება</TableCell>
                            <TableCell>ადმინის დადასტურება</TableCell>
                        </TableRow>
                    </TableHead>
                    {isLoading ? (
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <CircularProgress />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    ) : groups.length === 0 ? (
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <Typography variant="body1" color="textSecondary">მონაცემები არ მოიძებნა</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    ) : (
                        <TableBody>
                            {groups.map((group, index) => (
                                <TableRow
                                    key={index}
                                    onClick={() => {
                                        setSelectedGroup(group);
                                        setOpen(true);
                                    }}
                                    hover
                                    sx={{ cursor: 'pointer' }}
                                >
                                    <TableCell>
                                        {group.result.slice(0, 7).map(item => item.caseNumber).join(', ') + (group.result.length > 7 ? ', ...' : '')}
                                    </TableCell>
                                    <TableCell>{group.result.length}</TableCell>
                                    <TableCell>{areAllApproved(group) ? 'კი' : 'არა'}</TableCell>
                                    <TableCell>{areAllResolved(group) ? 'კი' : 'არა'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    )}
                </Table>
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={(_, newPage) => setPage(newPage)}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[]}
                />
            </TableContainer>

            <ConfirmationModal
                isOpen={isApproveModalOpen}
                onRequestClose={() => setIsApproveModalOpen(false)}
                onConfirm={approveCases}
            />
            <ConfirmationModal
                isOpen={isResolveModalOpen}
                onRequestClose={() => setIsResolveModalOpen(false)}
                onConfirm={resolveCases}
            />

            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg">
                <DialogTitle>განაცხადების დეტალები</DialogTitle>
                <DialogContent>
                    {selectedGroup?.result.map((item) => (
                        <Paper key={item.id} sx={{ p: 2, mb: 2 }}>
                            <Typography><b>განაცხადის ნომერი:</b> {item.caseNumber}</Typography>
                            <Typography><b>განმცხადებელი:</b> {item.requesterIdFullName}</Typography>
                            <Typography><b>ძველი განმცხადებელი:</b> {item.allOldRequesterIdFullNames}</Typography>
                            {roleId === "HEADOFAGENCY" && (
                                <Box mt={1}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => window.open(`/dashboard/mycases/casemanager?id=${item.caseId}`, '_blank')}
                                    >
                                        განაცხადის ნახვა
                                    </Button>
                                </Box>
                            )}

                        </Paper>
                    ))}

                    {selectedGroup && (
                        <Box display="flex" gap={2} justifyContent="flex-end" mt={2}>
                            {roleId === "HEADOFAGENCY" && !areAllApproved(selectedGroup) && (
                                <Button variant="contained" onClick={() => setIsApproveModalOpen(true)}>დადასტურება</Button>
                            )}
                            {roleId === "ROOTADMIN" && areAllApproved(selectedGroup) && !areAllResolved(selectedGroup) && (
                                <Button variant="contained" color="success" onClick={() => setIsResolveModalOpen(true)}>დადასტურება</Button>
                            )}
                        </Box>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default RewriteRequestTable;
